export enum MuscularStrengthInputKinds {
  Keyboard = 1,
  Click = 2,
}
